import { render } from "./ArticleEditPage.vue?vue&type=template&id=53339915"
import script from "./ArticleEditPage.vue?vue&type=script&lang=js"
export * from "./ArticleEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__